module.exports = __webpack_public_path__ + "img/i5gam-mobile5.42166e1a.png";